// extracted by mini-css-extract-plugin
export default {"InCartLink":"InCartLink-styles__InCartLink__OH4_e"};